/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetFullIssuedCardGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetFullIssuedCardRequest = {
  /**
   * The Moov business account for which the card was issued.
   */
  accountID: string;
  issuedCardID: string;
};

export type GetFullIssuedCardResponse = {
  headers: { [k: string]: Array<string> };
  result: components.FullIssuedCard;
};

/** @internal */
export const GetFullIssuedCardGlobals$inboundSchema: z.ZodType<
  GetFullIssuedCardGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetFullIssuedCardGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetFullIssuedCardGlobals$outboundSchema: z.ZodType<
  GetFullIssuedCardGlobals$Outbound,
  z.ZodTypeDef,
  GetFullIssuedCardGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getFullIssuedCardGlobalsToJSON(
  getFullIssuedCardGlobals: GetFullIssuedCardGlobals,
): string {
  return JSON.stringify(
    GetFullIssuedCardGlobals$outboundSchema.parse(getFullIssuedCardGlobals),
  );
}
export function getFullIssuedCardGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetFullIssuedCardGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetFullIssuedCardGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetFullIssuedCardGlobals' from JSON`,
  );
}

/** @internal */
export const GetFullIssuedCardRequest$inboundSchema: z.ZodType<
  GetFullIssuedCardRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  issuedCardID: z.string(),
});
/** @internal */
export type GetFullIssuedCardRequest$Outbound = {
  accountID: string;
  issuedCardID: string;
};

/** @internal */
export const GetFullIssuedCardRequest$outboundSchema: z.ZodType<
  GetFullIssuedCardRequest$Outbound,
  z.ZodTypeDef,
  GetFullIssuedCardRequest
> = z.object({
  accountID: z.string(),
  issuedCardID: z.string(),
});

export function getFullIssuedCardRequestToJSON(
  getFullIssuedCardRequest: GetFullIssuedCardRequest,
): string {
  return JSON.stringify(
    GetFullIssuedCardRequest$outboundSchema.parse(getFullIssuedCardRequest),
  );
}
export function getFullIssuedCardRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetFullIssuedCardRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetFullIssuedCardRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetFullIssuedCardRequest' from JSON`,
  );
}

/** @internal */
export const GetFullIssuedCardResponse$inboundSchema: z.ZodType<
  GetFullIssuedCardResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.FullIssuedCard$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetFullIssuedCardResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.FullIssuedCard$Outbound;
};

/** @internal */
export const GetFullIssuedCardResponse$outboundSchema: z.ZodType<
  GetFullIssuedCardResponse$Outbound,
  z.ZodTypeDef,
  GetFullIssuedCardResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.FullIssuedCard$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getFullIssuedCardResponseToJSON(
  getFullIssuedCardResponse: GetFullIssuedCardResponse,
): string {
  return JSON.stringify(
    GetFullIssuedCardResponse$outboundSchema.parse(getFullIssuedCardResponse),
  );
}
export function getFullIssuedCardResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetFullIssuedCardResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetFullIssuedCardResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetFullIssuedCardResponse' from JSON`,
  );
}
